// The mini-games' frames, each drawn only from its Aseprite exports: Bull Run (sprint 35 item 2) by client/bull-run-view.js,
// the bear's game (sprint 35 item 3) by client/bear-game-view.js, Hold the bags (sprint 36 item 3) by client/holden-game-view.js.
// Reduced motion: the background is a still frame (nothing scrolls or shakes); the sprites still step with the game.
// `after` counts the steps since the game ended (the throw's arc, the bell and "UP ONLY!", the bear's yawn and "STILL HERE!").
import { drawBull } from './bull-run-view.js';
import { drawBear } from './bear-game-view.js';
import { drawHolden } from './holden-game-view.js';

function bull(g, o, { reduced, after }) { return drawBull(g, o, { reduced, after }); }
function bear(g, o, { reduced, after, tell = null }) { return drawBear(g, o, { reduced, after, tell }); }

function holden(g, o, { reduced, after, tell = 'human' }) { return drawHolden(g, o, { reduced, after, tell }); }

export const DRAWERS = { bull, bear, holden };
export function drawFrame(g, gameId, obs, opts = {}) {
  g.imageSmoothingEnabled = false;
  return (DRAWERS[gameId] ?? DRAWERS.bull)(g, obs, { reduced: false, step: obs.t, after: 0, ...opts });
}
